import Axios from 'axios';
import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import Topbar from '../../Common/Topbar'
import Spinner from '../../Components/Spinner';
import config from '../../Shared/config';
import { TeacherCard } from '../Home/Teachers';
import './AllTeachers.scss'

export default class AllTeachers extends Component {
    constructor(props) {
        super(props)

        this.state = {
            teachersArray: [],
            teachersFetching: true,
            teachersFetched: false,
            moreFetching: false,
            // fetchNext: `${config.apiUrl}/Teacher/getall?skip=0`
            currentPageNumber: 1,
            prevPageNumber: null,
            nextPageNumber: null,
            pageSize: 10,
            count: 0
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.loadMore);
        this.setState({ nextPageNumber: 1 }, () => {
            this.fetchTeachers(this.state.currentPageNumber)
        })
    }

    fetchTeachers = (pageNumber) => {
        let { nextPageNumber, teachersArray } = this.state

        if (nextPageNumber) {

            this.setState({
                moreFetching: true
            })

            const url = `${config.apiUrl}/Teacher/getall?pageNumber=${nextPageNumber}`;
            Axios.get(url).then(res => {
                if (!res.data.error) {
                    let data = res.data.data.listData || []
                    let currentPageNumber = res.data.data.currentPageNumber || 1
                    let prevPageNumber = res.data.data.prevPageNumber
                    let nextPageNumber = res.data.data.nextPageNumber
                    let pageSize = res.data.data.pageSize
                    let count = res.data.data.count

                    teachersArray.push(...data)

                    this.setState({
                        teachersArray: teachersArray,
                        teachersFetching: false,
                        teachersFetched: true,
                        moreFetching: false,
                        currentPageNumber,
                        prevPageNumber,
                        nextPageNumber,
                        pageSize,
                        count
                    })

                } else {

                    alert(res.data.message)

                    this.setState({
                        teachersArray: [],
                        teachersFetching: false,
                        teachersFetched: true,
                        moreFetching: false
                    })

                }
                window.addEventListener('scroll', this.loadMore);
            }).catch(err => {
                console.error(err)

                this.setState({
                    teachersArray: [],
                    teachersFetching: false,
                    teachersFetched: true,
                    moreFetching: false
                })

                window.addEventListener('scroll', this.loadMore);
            })
        }

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.loadMore);
    }

    loadMore = () => {
        const { teachersFetching, moreFetching } = this.state
        if (!teachersFetching && !moreFetching) {
            let scrollTop = window.innerHeight + document.documentElement.scrollTop
            let scrollHeight = document.scrollingElement.scrollHeight - 60
            console.log({
                ScrollTop: scrollTop,
                ScrollHeight: scrollHeight
            })
            if (scrollTop >= scrollHeight) {
                this.fetchTeachers(this.state.nextPageNumber)
            }
        }
    }

    render() {

        const { teachersArray, teachersFetching, teachersFetched, moreFetching, nextPageNumber } = this.state

        return (
            <div className='allteachers'>
                <Topbar type={'fixedover'} theme={'solid'} />
                <div className="allteachers__content">
                    <div className='teachers'>

                        <h1>Teachers  <img alt='features' src={'https://www.flaticon.com/svg/static/icons/svg/2436/2436654.svg'}></img></h1>
                        {
                            teachersFetching ? (
                                <>
                                    <div style={{ padding: '20px 0px' }} className="space"></div>
                                    <Spinner />
                                    <div style={{ padding: '20px 0px' }} className="space"></div>
                                </>

                            ) : (
                                    teachersFetched ? (
                                        <>
                                            <div className="cards">
                                                {
                                                    teachersArray.map((item, idx) => {
                                                        return <Link to={`/teacher/${item._id}`}><TeacherCard teacher={item} /></Link>
                                                    })
                                                }
                                            </div>

                                            {
                                                moreFetching ? (
                                                    <>
                                                        <div style={{ padding: '20px 0px' }} className="space"></div>
                                                        <Spinner />
                                                        <div style={{ padding: '20px 0px' }} className="space"></div>
                                                    </>
                                                ) : null
                                            }

                                        </>
                                    ) : null
                                )
                        }
                        {
                            !nextPageNumber ? (
                                <div className="result-end">
                                    Oh no! We ran out of suggestions. <span role='img' aria-label='astonished'>😟</span>
                                </div>
                            ) : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}
